import { useState } from "react";
import { BioShell, ResultCard, primaryBtn, BIO_ACCENT } from "./BioShell.jsx";
import { punnettMono, punnettDi } from "./biocore.js";

export default function Punnett() {
  const [mode, setMode] = useState("mono");
  const [p1, setP1] = useState("Aa");
  const [p2, setP2] = useState("Aa");
  const [res, setRes] = useState(null);

  const run = () => setRes(mode === "mono" ? punnettMono(p1, p2) : punnettDi(p1, p2));
  const switchMode = (m) => {
    setMode(m);
    setRes(null);
    if (m === "mono") { setP1("Aa"); setP2("Aa"); }
    else { setP1("AaBb"); setP2("AaBb"); }
  };

  return (
    <BioShell title="Punnett Square">
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[["mono", "Monohybrid"], ["di", "Dihybrid"]].map(([k, l]) => (
          <button key={k} onClick={() => switchMode(k)} style={{ flex: 1, background: mode === k ? BIO_ACCENT : "#1C1E2E", color: mode === k ? "#04240F" : "#9A9DBE", border: "none", borderRadius: 10, padding: "10px 0", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
            {l}
          </button>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <label style={{ fontSize: 13, color: "#9A9DBE" }}>Parent 1
          <input value={p1} onChange={(e) => setP1(e.target.value)} style={inp} />
        </label>
        <label style={{ fontSize: 13, color: "#9A9DBE" }}>Parent 2
          <input value={p2} onChange={(e) => setP2(e.target.value)} style={inp} />
        </label>
      </div>
      <p style={{ fontSize: 12, color: "#5B5E7A" }}>
        {mode === "mono" ? "Two alleles each, e.g. Aa × Aa" : "Four alleles each, e.g. AaBb × AaBb"}
      </p>
      <button onClick={run} style={primaryBtn}>Cross</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          {res.grid && (
            <table style={{ borderCollapse: "collapse", margin: "0 auto 16px" }}>
              <tbody>
                {res.grid.map((row, i) => (
                  <tr key={i}>
                    {row.map((cell, j) => (
                      <td key={j} style={{ border: "1px solid #2A2C3D", padding: "12px 18px", textAlign: "center", fontFamily: "ui-monospace, monospace", fontSize: 16, color: BIO_ACCENT, fontWeight: 700 }}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 6 }}>GENOTYPE RATIO (of {res.total})</div>
          <div style={{ fontSize: 14, color: "#C8CADF", marginBottom: 12 }}>
            {Object.entries(res.genotypes).map(([g, n]) => `${n} ${g}`).join("  :  ")}
          </div>
          <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 6 }}>PHENOTYPE RATIO</div>
          <div style={{ fontSize: 14, color: "#C8CADF" }}>
            {Object.entries(res.phenotypes).map(([p, n]) => `${n} ${p}`).join("  :  ")}
          </div>
        </ResultCard>
      )}
    </BioShell>
  );
}
const inp = { width: "100%", background: "#13141F", border: "1px solid #262839", borderRadius: 10, color: "#E8E9F3", fontSize: 16, padding: "12px 14px", boxSizing: "border-box", marginTop: 6, fontFamily: "ui-monospace, monospace" };

